<template>
  <NewShopNoOA />
</template>
<script>
import NewShopNoOA from "@/components/NewShopNoOA";
export default {
  components: {
    NewShopNoOA
  }
}
</script>